import {createSelector} from 'reselect';

import {ApplicationStoreType} from 'reducers';
import {StoreInfoType} from 'reducers/storeInfo/storeInfoType';

/**
 * Returns organisational info from store
 * @param {ApplicationStoreType} store - Current store
 * @returns {StoreInfoType} - organisational info
 */
export const getStoreInfoState = (store: ApplicationStoreType): StoreInfoType => store.storeInfo;

/**
 * Returns default phone from store info
 *
 * @param {ApplicationStoreType} store - Current store
 * @returns {string} default store info phone
 */
export const getDefaultStorePhone = createSelector(
    getStoreInfoState,
    (storeInfo): string => storeInfo.phones.default,
);
